export default __webpack_public_path__ + "static/CharterITCW05-Regular-ac6fb834b08432e8c6c5afa7db03ef5f.woff2";